export const serverUrl = process.env.MAPSERVICE_URL;

export const IDOTRoadsLayer = 0;

export const PavementConditionGroup = 1;

export const CRSMarkedGroup = 2;
export const CRSTicsMarkedLayer = 3;
export const CRSOpposingMarkedLayer = 4;
export const CRSWithMarkedLayer = 5;
export const CRSMarkedLayer = 6;
export const CRSUnmarkedGroup = 7;
export const CRSTicsUnmarkedLayer = 8;
export const CRSOpposingUnmarkedLayer = 9;
export const CRSWithUnmarkedLayer = 10;
export const CRSUnmarkedLayer = 11;

export const IRIMarkedGroup = 12;
export const IRIOpposingMarkedLayer = 13;
export const IRIWithMarkedLayer = 14;
export const IRIMarkedLayer = 15;
export const IRIUnmarkedGroup = 16;
export const IRIOpposingUnmarkedLayer = 17;
export const IRIWithUnmarkedLayer = 18;
export const IRIUnmarkedLayer = 19;

export const RuttingMarkedGroup = 20;
export const RUTOpposingMarkedLayer = 21;
export const RUTWithMarkedLayer = 22;
export const RUTMarkedLayer = 23;
export const RuttingUnmarkedGroup = 24;
export const RUTOpposingUnmarkedLayer = 25;
export const RUTWithUnmarkedLayer = 26;
export const RUTUnmarkedLayer = 27;

export const NHSStateandLocalJurisdictionLayer = 28;
export const NonNHSStateJurisdictionLayer = 29;

export const ProgrammingDataGroup = 30;
export const MYPSpotLayerCurYear = 31;
export const MYPSpotLayerFutureYears = 32;
export const MYPStructuresLayerCurYear = 33;
export const MYPStructuresLayerFutureYears = 34;
export const MYPRoadwayLayerCurYear = 35;
export const MYPRoadwayLayerFutureYears = 36;
export const AnnualBridgeImprovement = 37;
export const AnnualConstructionLayer = 38;
export const AnnualEngineeringLayer = 39;
export const AnnualLandAcqLayer = 40;
export const FTRStructuresLayer = 41;
export const FTREngineeringLayer = 42;
export const FTRConstructionLayer = 43;
export const FTRLandAcqLayer = 44;

export const StateStructuresGroup = 45;
export const StateStructuresLayer = 46;
export const LocalStructuresLayer = 47;

export const RoadwayClassificationGroup = 48;
export const NHSLayer = 49;
export const JurisdictionLayer = 50;
export const FunctionalClassLayer = 51;
export const SignificantRoutesWorkZoneSafetyandMobilityPolicyLayer = 52;
export const SpeedLimitLayer = 53;
export const DTRSMPostedStructures = 54;
export const DTRLMPostedStructures = 55;
export const DTRLocalTruckRoute = 56;
export const DTRSMTruckRoute = 57;
export const DTRLMTruckRoute = 58;
export const DTRLMTruckRouteWith = 59;
export const DTRLMTruckRouteAgainst = 60;

export const TrafficCountGroup = 61;
export const AnnualAverageDailyTraffic = 62;
export const HCVLayer = 63;
export const SULayer = 64;
export const MULayer = 65;
export const TurningMovementDataLayer = 66;

export const BoundaryLayersGroup = 67;
export const IDOTDistrictsLayer = 68;
export const USCongressBoundariesLayer = 69;
export const IlHouseBoundariesLayer = 70;
export const ILSenateBoundariesLayer = 71;
export const PoliticalTownshipsLayer = 72;
export const IllinoisCountiesLayer = 73;
export const UrbanAreasLayer = 74;
export const MPOAreasLayer = 75;
export const IllinoisTownsLayer = 76;

export const OtherLayersGroup = 77;
export const AirportsLayer = 78;
export const MahometAquiferLayer = 79;
export const VanPicsRoadLayer = 80;
export const VanPicsIDOTRoadLayer = 92;
export const RestAreasLayer = 88;
export const RRXCrossingLayer = 89;

export const QueryLayersGroup = 81;
export const RoadConditionQueryLayer = 82;
export const StateKRLayerWith = 83;
export const StateKRLayerAgainst = 84;
export const CRSHistoricalLayer = 85;

export const FeatureUpdateLayer = 86;
export const PPSSearchTable = 87;

export const StructurePlansLayer = 93;
export const RoadwayPlansLayer = 94;

